import React, { createContext, useContext, useState, useEffect } from 'react';
import API, { formatError } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading
  const [error, setError] = useState(null);

  useEffect(() => {
    API.get('/auth/me')
      .then(r => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  const login = async (email, password) => {
    setError(null);
    try {
      const { data } = await API.post('/auth/login', { email, password });
      setUser(data);
      return { success: true };
    } catch (e) {
      const msg = formatError(e);
      setError(msg);
      return { success: false, error: msg };
    }
  };

  const register = async () => ({ success: false, error: 'Registration is disabled. Ask an admin for an invitation.' });

  const logout = async () => {
    try {
      await API.post('/auth/logout');
    } catch (_) {}
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, error, login, register, logout, loading: user === undefined }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
